module.exports = __webpack_public_path__ + "static/media/024-bad habits.5a40cbf6.svg";